module.exports = __webpack_public_path__ + "media/pages/press/downloads/thumbnails/pdf_tn-36eb31422aa18c3aab682280004cd20f.jpg";